import type { ConfirmOptions } from 'material-ui-confirm';

export const defaultConfirmationProps: ConfirmOptions = {
  contentProps: {},
  confirmationButtonProps: {
    autoFocus: true,
    size: 'small',
    variant: 'contained'
  },
  cancellationButtonProps: {
    color: 'secondary',
    size: 'small',
    variant: 'text'
  },
  allowClose: true,
  dialogProps: {
    sx: {
      // Uses dialogNested as confirmation dialogs are always opened from other dialogs
      zIndex: (theme) => theme.zIndex.dialogNested
    },
    // Add a data attribute to identify confirmation dialogs
    // @ts-expect-error - data attributes are valid HTML but not in MUI types
    'data-confirmation-dialog': 'true'
  }
};
